<script lang="ts">
    import AutoCompletableInput from './Maps/AutoCompletableInput.svelte';

    import type { Language } from '$lib/types/Language';

    // Final Form
    export let finalFormInput;

    // Text
    export let placeholder = '';
    export let emoji = '';
    export let showEmoji = true;
    export let required = false;
    export let pristine = false;
    export let touched = false;
    export let active = false;

    // Validation
    export let invalid = false;
    export let errorMessage = '';

    // Styling
    export let focusColor = '';
    export let outlineColor = '';

    // Localisation
    export let language: Language = 'en';
</script>

<AutoCompletableInput
    type="postal"
    {placeholder}
    {emoji}
    {showEmoji}
    {invalid}
    {active}
    {pristine}
    {required}
    {focusColor}
    {outlineColor}
    {touched}
    {finalFormInput}
    {errorMessage}
    {language}
/>
